import BaseModal from 'app/views/modals/base_modal';
import BankAccount from 'app/models/bank_account';

import { showSuccess, showResponseError } from 'utils/messages';
import tmpl from 'templates/bank_account_details_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .create_account': 'createAccount',
  },

  initialize(options) {
    this.priority = options.priority;
  },

  createAccount(event) {
    event.preventDefault();
    const self = this;
    const account = new BankAccount();
    account.save({
      account_number: this.$('#bank_account_number').val(),
      routing_number: this.$('#bank_account_routing_number').val(),
      account_holder_name: this.$('#bank_account_account_holder_name').val(),
      account_holder_type: this.$('input[name="bank_account_account_holder_type"]:checked').val(),
      country: this.$('#bank_account_country').val(),
      priority: this.priority,
    }, {
      wait: true,
      success(model) {
        self.model.set(`${self.priority}_payment_method`, model);
        showSuccess('Bank account successfully linked to your account.');
        self.close();
      },
      error(model, response) {
        showResponseError(response);
        self.close();
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/bank_account_details_modal.js